import PropTypes from "prop-types";
import React from "react";
import { Report } from "powerbi-report-component";
import Unauthorized from "app/pages/Unauthorized";
import { createGlobalStyle } from "styled-components";
import env from "react-dotenv";

const BusinessIntelligencePageStyles = createGlobalStyle`
iframe{
    border: none;
}
`;

const PowerBIReport = ({ reportData }) => {
    const reportStyle = {
        width: "100%",
        height: "90vh",
    };

    const settings = {
        filterPaneEnabled: false,
        navContentPaneEnabled: false,
        layoutType: 0,
    };

    const { token, dashboardId, reportId, pageName } = reportData;
    const embedURL = `https://app.powerbi.com/reportEmbed?reportId=${reportId}&groupId=${dashboardId}&w=2&${env.POWERBI_NAVIGATION_MAIN_REPORT_URL}`;

    return token && reportId && dashboardId ? (
        <>
            <BusinessIntelligencePageStyles />
            <Report
                tokenType="Aad"
                accessToken={token}
                embedUrl={embedURL}
                embedId={reportId}
                permissions="All"
                style={reportStyle}
                extraSettings={settings}
                pageName={pageName}
            />
        </>
    ) : (
        <Unauthorized />
    );
};

PowerBIReport.propTypes = {
    reportData: PropTypes.shape({
        token: PropTypes.string,
        dashboardId: PropTypes.string,
        reportId: PropTypes.string,
        pageName: PropTypes.string
    }).isRequired
};

export default PowerBIReport;
